import { AutoAwesome } from "@mui/icons-material";
import { Grid } from "../../basics/Grid";
import { IconButton } from "../../basics/IconButton";
import { Paper } from "../../basics/Paper";
import { Typography } from "../../basics/Typography";
import { ISectionProps } from "./types";

const Section = (props: ISectionProps) => {
    return (
        <Paper sx={{ mt: 1 }}>
            <Grid
                container
                justifyContent="space-between"
                data-testid="section-content-grid"
            >
                <Grid item>
                    <Grid
                        container
                        gap={1}
                        className="section__header"
                        alignItems="center"
                    >
                        {props.icon}
                        <Typography variant='h3'>
                            {props.title}
                        </Typography>
                        {props.titleAdornment}
                    </Grid>
                    {
                        props.subtitle && <Grid sx={{ mt: 1 }}>
                            <Typography variant="caption">
                                {props.subtitle}
                            </Typography></Grid>
                    }

                </Grid>
                <Grid item>
                    <Grid
                        container
                        gap={2}
                        alignItems="center"
                    >
                        {props.headerComponents}
                        {props.onClickAIButton && (
                            <IconButton onClick={props.onClickAIButton}>
                                <AutoAwesome />
                            </IconButton>
                        )}
                    </Grid>
                </Grid>
            </Grid>
            <Grid container={props.flex} gap={2} mt={1}>
                {props.children}
            </Grid>
        </Paper >
    )
}

export { Section };

